import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Ab wann hat Petra eine Verbesserung bemerkt?',
  a: 'Bereits nach 7–10 Tagen zeigte Rex deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
}, {
  q: 'Ist das Topping auch für empfindliche Hunde geeignet?',
  a: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
}, {
  q: 'Wie viel gibt man täglich?',
  a: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Petra hat mit der kleinsten Menge angefangen und langsam gesteigert.'
}, {
  q: 'Was wenn es bei meinem Hund nicht wirkt?',
  a: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-16 px-4 md:px-8 max-w-3xl mx-auto" data-id="element-89">
      <h2 className="text-center font-handwritten text-4xl text-forest-green font-bold mb-10" data-id="element-90">
        Häufige Fragen
      </h2>

      <div className="space-y-4" data-id="element-91">
        {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-warm-brown/10 overflow-hidden" data-id="element-92">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center bg-white hover:bg-cream/50 transition-colors" data-id="element-93">
              <span className="font-bold text-gray-800 pr-4" data-id="element-94">{faq.q}</span>
              <ChevronDown className={`text-forest-green transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-95" />
            </button>

            <AnimatePresence data-id="element-96">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-97">
                  <div className="px-6 pb-4 pt-2 text-gray-600 leading-relaxed border-t border-warm-brown/5" data-id="element-98">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}